import { Card, List, ListItem, Skeleton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import ShiftItem from "./ShiftItem";
import { ShiftItemFragment } from "./ShiftItem/fragments.generated";

interface FieldworkerShiftsProps {
    data: ShiftItemFragment[] | undefined;
    loading: boolean;
}

export default function FieldworkerShifts({ data, loading }: FieldworkerShiftsProps) {
    const { t } = useTranslation("fieldworker");

    if (loading) {
        return <Skeleton variant="rounded" width="100%" height={180} />;
    }

    if (data == null || data.length === 0) {
        return (
            <Card variant="outlined" sx={theme => ({ backgroundColor: theme.palette.background.paper })}>
                <Typography variant="h6" textAlign="center" py="32px">
                    {t("shifts.noShifts")}
                </Typography>
            </Card>
        );
    }

    return (
        <List disablePadding>
            {data.map(shift => (
                <ListItem key={shift.id} disableGutters>
                    <ShiftItem shift={shift} />
                </ListItem>
            ))}
        </List>
    );
}
